import { GET_ACTIVITY_CATEGORIES } from '../Actions/actionName'

const ActivityCategories = (state = {}, action) => {
  switch (action.type) {
    case GET_ACTIVITY_CATEGORIES:
      return action;
    default:
      return state;
  }
};

export default ActivityCategories;
